import React, { useState, useEffect } from 'react';
import { Form, Button, Table, Container, Modal, FormGroup, FormControl, FormLabel, Tabs, Tab, Toast, ToastContainer, Badge, Alert } from 'react-bootstrap';
import { collection,  updateDoc, deleteDoc, doc, runTransaction, onSnapshot, getFirestore, writeBatch } from 'firebase/firestore';
import {  storage } from '../../../firebase/firebase';
import { ref as storageRef, uploadBytes, getDownloadURL } from 'firebase/storage';
import TiptapEditor from '../../../components/TiptapEditor/TiptapEditor';
import '../../../theme/tiptap-editor.scss';
import '../../../theme/modal-consistency.scss';
import '../../../theme/letter-format.scss';
import {
    DndContext,
    closestCenter
} from '@dnd-kit/core';
import {
    arrayMove,
    SortableContext,
    verticalListSortingStrategy,
    useSortable
} from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import Swal from 'sweetalert2';
import './MaterialTeorico.css'; 
import NavbarGlobal from '../../NavbarGlobal';

const FormularioAgregarLeccion = ({ leccionActual, setLeccionActual, handleAddLeccion, handleImageChange }) => (
    <Form className="lesson-form-shell" onSubmit={handleAddLeccion}>
        <div className="lesson-form-grid">
            <Form.Group className="mb-3">
                <Form.Label>Nivel</Form.Label>
                <Form.Select value={leccionActual.level} onChange={(e) => setLeccionActual({ ...leccionActual, level: e.target.value })}>
                    <option value="">Selecciona un nivel</option>
                    <option value="1">Nivel 1</option>
                    <option value="2">Nivel 2</option>
                    <option value="3">Nivel 3</option>
                </Form.Select>
            </Form.Group>
            <Form.Group className="mb-3 lesson-title-field">
                <Form.Label>Titulo</Form.Label>
                <Form.Control
                    type="text"
                    value={leccionActual.titulo}
                    onChange={(e) => setLeccionActual(prev => ({ ...prev, titulo: e.target.value }))}
                    placeholder="Ingresa el titulo de la leccion"
                    autoComplete="off"
                />
            </Form.Group>
            <Form.Group className="mb-3">
                <Form.Label>Columnas</Form.Label>
                <Form.Select value={leccionActual.columnasDescripcion} onChange={(e) => setLeccionActual({ ...leccionActual, columnasDescripcion: e.target.value })}>
                    <option value="1">1 columna</option>
                    <option value="2">2 columnas</option>
                </Form.Select>
            </Form.Group>
            <Form.Group className="mb-3">
                <Form.Label>Imagen destacada</Form.Label>
                <Form.Control
                    type="file"
                    onChange={handleImageChange}
                    accept="image/*"
                />
            </Form.Group>
        </div>

        <Form.Group className="mb-3">
            <Form.Label>Descripcion</Form.Label>
            <div className="lesson-editor-surface">
                <TiptapEditor
                    value={leccionActual.descripcion}
                    onChange={content => setLeccionActual({ ...leccionActual, descripcion: content })}
                    placeholder="Ingresa una descripcion"
                    columnCount={leccionActual.columnasDescripcion}
                    className="lesson-tiptap-editor"
                />
            </div>
        </Form.Group>
        <div className="lesson-form-actions">
            <Button variant="primary" type="submit">Añadir leccion</Button>
        </div>
    </Form>
);

const AddMaterialTeorico = () => {
    const [lecciones, setLecciones] = useState([]);
    const [leccionActual, setLeccionActual] = useState({ level: '', titulo: '', descripcion: '', imagenDestacada: '', columnasDescripcion: '1'  });
    const [imageFile, setImageFile] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [editingLesson, setEditingLesson] = useState(null);
    const [activeNivelTab, setActiveNivelTab] = useState('nivel1'); // Estado para manejar la pestaña activa de niveles
    // Estado para controlar la visibilidad del toast
    const [showToast, setShowToast] = useState(false);
    const [deleteImage, setDeleteImage] = useState(false);
    // Estado para la pestaña principal (formulario o lecciones)
    const [mainTab, setMainTab] = useState('formulario');
    const [isLoading, setIsLoading] = useState(true);
    const [toastMessage, setToastMessage] = useState('');

    const db = getFirestore();  // Asegúrate de que estás usando la instancia correcta de Firestore

    // Función para cerrar el modal y reiniciar el estado de edición
    const handleCloseModal = () => {
        setShowModal(false);
        setEditingLesson(null);  // Reiniciar el estado de la lección que se está editando
    };

    // Obtener las lecciones desde Firestore
    useEffect(() => {
        const obtenerLeccionesEnTiempoReal = () => {
            setIsLoading(true);
            const leccionesRef = collection(db, 'Lecciones');
            const unsubscribe = onSnapshot(leccionesRef, (snapshot) => {
                const leccionesActualizadas = snapshot.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data(),
                    level: doc.data().level.toString(),
                    columnasDescripcion: doc.data().columnasDescripcion || '1'
                }));
                
                // Aplicar el orden guardado en localStorage si existe
                const ordenGuardado = localStorage.getItem('ordenLecciones');
                if (ordenGuardado) {
                    try {
                        const ordenParseado = JSON.parse(ordenGuardado);
                        // Creamos un mapa para acceder rápidamente al orden de cada lección
                        const ordenMap = new Map();
                        ordenParseado.forEach((item, index) => {
                            ordenMap.set(item.id, index);
                        });
                        
                        // Aplicamos el orden a las lecciones obtenidas de Firestore
                        leccionesActualizadas.sort((a, b) => {
                            const ordenA = ordenMap.has(a.id) ? ordenMap.get(a.id) : Number.MAX_SAFE_INTEGER;
                            const ordenB = ordenMap.has(b.id) ? ordenMap.get(b.id) : Number.MAX_SAFE_INTEGER;
                            return ordenA - ordenB;
                        });
                    } catch (error) {
                        console.error("Error al procesar el orden guardado:", error);
                    }
                } else {
                    // Si no hay orden guardado, ordenamos por el campo 'orden'
                    leccionesActualizadas.sort((a, b) => {
                        const ordenA = a.orden || Number.MAX_SAFE_INTEGER;
                        const ordenB = b.orden || Number.MAX_SAFE_INTEGER;
                        return ordenA - ordenB;
                    });
                }
                
                setLecciones(leccionesActualizadas);
                setIsLoading(false);
            });
        
        return () => unsubscribe();
        };
    
        obtenerLeccionesEnTiempoReal();
    }, [db]);

    const handleImageChange = (event) => {
        if (event.target.files[0]) {
            setImageFile(event.target.files[0]);
        }
    };

    // Añadir una nueva lección
    const handleAddLeccion = async (event) => {
        event.preventDefault();
        if (!leccionActual.level || !leccionActual.titulo || !leccionActual.descripcion) {
            Swal.fire('Error', 'Por favor, completa todos los campos obligatorios antes de guardar.', 'error');
            return;
        }
    
        const contadorRef = doc(db, "Contadores", `nivel_${leccionActual.level}`);
        try {
            await runTransaction(db, async (transaction) => {
                const contadorDoc = await transaction.get(contadorRef);
                let nuevoContador = 1;
    
                if (contadorDoc.exists()) {
                    nuevoContador = contadorDoc.data().contador + 1;
                }
    
                let downloadURL = '';
                if (imageFile && imageFile.name) { // Verificación adicional aquí
                    const imageExtension = imageFile.name.split('.').pop();
                    const imageName = `${nuevoContador}-${leccionActual.titulo.replace(/ /g, '_')}-${Date.now()}.${imageExtension}`;
                    const storagePath = `lecciones/${imageName}`;
                    const imageRef = storageRef(storage, storagePath);
                    const snapshot = await uploadBytes(imageRef, imageFile);
                    downloadURL = await getDownloadURL(snapshot.ref);
                }
    
                const updatedLeccion = {
                    ...leccionActual,
                    level: leccionActual.level.toString(),
                    imagenDestacada: downloadURL,
                    id: nuevoContador.toString(),
                    orden: nuevoContador
                };
    
                transaction.set(doc(collection(db, 'Lecciones'), updatedLeccion.id), updatedLeccion);
                transaction.update(contadorRef, { contador: nuevoContador });
    
                setLecciones([...lecciones, updatedLeccion]);
                setLeccionActual({ level: '', titulo: '', descripcion: '', imagenDestacada: '', columnasDescripcion: '1' });
                setImageFile(null);
                Swal.fire('Éxito', 'Lección guardada con éxito.', 'success');
                // Cambiar automáticamente a la pestaña "Lecciones" después de guardar
                setMainTab('lecciones');
                setToastMessage('Lección guardada con éxito.');
                setShowToast(true);
            });
        } catch (error) {
            console.error("Error al guardar la lección:", error);
            Swal.fire('Error', 'Ocurrió un error al guardar la lección.', 'error');
        }
    };
    
    
    

    // Editar una lección
    const handleEdit = (leccion) => {
        if (!leccion.id) {
            console.error('Error: La lección seleccionada no tiene un ID válido.');
            return;
        }

        setEditingLesson({
            ...leccion,
            level: leccion.level.toString(),
            columnasDescripcion: leccion.columnasDescripcion || '1'
        });
        setImageFile(null);
        setDeleteImage(false);
        setShowModal(true);
    };

    const handleUpdateLesson = async (leccion) => {
        if (!leccion.level || !leccion.titulo || !leccion.descripcion) {
            Swal.fire('Error', 'Por favor, completa todos los campos requeridos.', 'error');
            return;
        }

        try {
            const leccionRef = doc(db, 'Lecciones', leccion.id);
            const updatedFields = {
                level: leccion.level,
                titulo: leccion.titulo,
                descripcion: leccion.descripcion,
                columnasDescripcion: leccion.columnasDescripcion || '1'
            };

            if (imageFile) {
                const imageUrl = await uploadImage(leccion.id);
                if (imageUrl) {
                    updatedFields.imagenDestacada = imageUrl;
                }
            } else if (deleteImage) {
                updatedFields.imagenDestacada = '';
            } else {
                updatedFields.imagenDestacada = leccion.imagenDestacada;
            }

            await updateDoc(leccionRef, updatedFields);
            
            // Actualizar el estado local
            setLecciones(prevLecciones => 
                prevLecciones.map(l => 
                    l.id === leccion.id ? { ...l, ...updatedFields } : l
                )
            );

            setImageFile(null);
            setDeleteImage(false);
            handleCloseModal();
            
            Swal.fire('Éxito', 'Lección actualizada con éxito.', 'success');
            setToastMessage('Lección actualizada con éxito.');
            setShowToast(true);
        } catch (error) {
            console.error("Error al actualizar la lección:", error);
            Swal.fire('Error', 'Ocurrió un error al actualizar la lección.', 'error');
        }
    };

    // Función para cargar la imagen
    const uploadImage = async (lessonId) => {
        if (!imageFile || !imageFile.name) return null;
    
        const imageExtension = imageFile.name.split('.').pop();
        const imageName = `${lessonId}-${Date.now()}.${imageExtension}`;
        const storagePath = `lecciones/${imageName}`;
        const imageRef = storageRef(storage, storagePath);
    
        const snapshot = await uploadBytes(imageRef, imageFile);
        return await getDownloadURL(snapshot.ref);
    };

    // Función para cargar imágenes del editor
    const handleEditorImageUpload = async (file) => {
        try {
            console.log('Iniciando carga de imagen:', file.name);
            const imageExtension = file.name.split('.').pop();
            const imageName = `editor-${Date.now()}-${Math.random().toString(36).substr(2, 9)}.${imageExtension}`;
            const storagePath = `lecciones/editor/${imageName}`;
            const imageRef = storageRef(storage, storagePath);
            
            console.log('Subiendo imagen a Firebase Storage...');
            const snapshot = await uploadBytes(imageRef, file);
            console.log('Imagen subida, obteniendo URL de descarga...');
            const downloadURL = await getDownloadURL(snapshot.ref);
            console.log('URL de descarga obtenida:', downloadURL);
            return downloadURL;
        } catch (error) {
            console.error('Error uploading editor image:', error);
            // No mostrar Swal aquí, ya que se maneja en el componente padre
            throw error; // Propagar el error para manejarlo en el componente padre
        }
    };
    void handleEditorImageUpload;
    

    // Eliminar una lección
    const handleDelete = async (id) => {
        try {
            const result = await Swal.fire({
                title: '¿Estás seguro?',
                text: "Esta acción no se puede deshacer",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sí, eliminar',
                cancelButtonText: 'Cancelar'
            });

            if (result.isConfirmed) {
                await deleteDoc(doc(db, 'Lecciones', id));
                setLecciones(lecciones.filter(leccion => leccion.id !== id));
                Swal.fire('Éxito', 'Lección eliminada con éxito.', 'success');
                setToastMessage('Lección eliminada con éxito.');
                setShowToast(true);
            }
        } catch (error) {
            console.error("Error al eliminar la lección:", error);
            Swal.fire('Error', 'Ocurrió un error al eliminar la lección.', 'error');
        }
    };

   // Reordenar las lecciones mediante Drag and Drop
   const handleOnDragEnd = (event) => {
    const { active, over } = event;
    if (!over || active.id === over.id) return;
    // Obtener el nivel activo
    const nivelActivo = activeNivelTab.replace('nivel', '');
    // Filtrar solo las lecciones del nivel activo
    const leccionesNivel = lecciones.filter(l => l.level === nivelActivo);
    const oldIndex = leccionesNivel.findIndex(l => l.id === active.id);
    const newIndex = leccionesNivel.findIndex(l => l.id === over.id);
    if (oldIndex === -1 || newIndex === -1) return;
    // Reordenar solo las del nivel activo
    const reorderedNivel = arrayMove(leccionesNivel, oldIndex, newIndex);
    // Reconstruir el array completo
    const nuevasLecciones = lecciones.map(l =>
        l.level === nivelActivo ? reorderedNivel.shift() : l
    );
    setLecciones(nuevasLecciones);
    localStorage.setItem('ordenLecciones', JSON.stringify(nuevasLecciones));
    setShowToast(true);
    saveOrderInDatabase(nuevasLecciones);
};

// Función para debouncing
const debounce = (func, delay) => {
    let timer;
    return function(...args) {
        clearTimeout(timer);
        timer = setTimeout(() => func.apply(this, args), delay);
    };
};

// Usar debounce para el guardado en Firebase
const saveOrderInDatabase = debounce(async (items) => {
    const batch = writeBatch(db);
    items.forEach((item, index) => {
        const leccionRef = doc(db, 'Lecciones', item.id);
        batch.update(leccionRef, { orden: index + 1 });
    });

    await batch.commit();  // Guardar el batch en Firebase
}, 2000);  // Esperar 2 segundos antes de guardar







    // Componente SortableRow para usar con dnd-kit
    function DragHandle({ listeners, attributes }) {
        return (
            <span
                {...listeners}
                {...attributes}
                style={{ cursor: 'grab', marginRight: 8, color: '#888', fontSize: '1.2em', userSelect: 'none' }}
                title="Arrastrar para reordenar"
            >
                ☰
            </span>
        );
    }

    function SortableRow({ id, children }) {
        const {
            attributes,
            listeners,
            setNodeRef,
            transform,
            transition,
            isDragging
        } = useSortable({ id });
        const style = {
            transform: CSS.Transform.toString(transform),
            transition,
            background: isDragging ? '#f4f4f4' : undefined
        };
        return (
            <tr ref={setNodeRef} style={style} className={`sortable-row ${isDragging ? 'dragging' : ''}`}>
                {/* Título con handle de drag */}
                <td className="fw-semibold d-flex align-items-center">
                    <DragHandle listeners={listeners} attributes={attributes} />
                    <span className="me-2">📚</span>
                    {children[0]}
                </td>
                {/* Posición */}
                {children[1]}
                {/* Acciones */}
                {children[2]}
            </tr>
        );
    }

    // Componente de la lista de lecciones
    const ListadoLecciones = () => (
        <div>
            <div className="lecturas-header">
                <h3>Listado de Lecciones</h3>
                <p className="text-muted">Administra las lecciones teóricas para cada nivel</p>
            </div>
            <Alert variant="info" className="mb-4">
                <Alert.Heading>📚 Gestión de Lecciones</Alert.Heading>
                <p>
                    Aquí puedes ver, editar y eliminar las lecciones existentes. También puedes reordenar las lecciones arrastrándolas desde el ícono ☰.
                </p>
            </Alert>
            {isLoading ? (
                <div className="text-center py-5">
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Cargando...</span>
                    </div>
                    <p className="mt-3">Cargando lecciones...</p>
                </div>
            ) : (
                <Tabs activeKey={activeNivelTab} onSelect={(k) => setActiveNivelTab(k)} className="mb-3">
                    {['1', '2', '3'].map(nivel => (
                        <Tab eventKey={`nivel${nivel}`} title={`Nivel ${nivel}`} key={nivel}>
                            <DndContext collisionDetection={closestCenter} onDragEnd={handleOnDragEnd}>
                                <SortableContext
                                    items={lecciones.filter(leccion => leccion.level === nivel).map(l => l.id)}
                                    strategy={verticalListSortingStrategy}
                                >
                                    <Table striped bordered hover className="table-suave">
                                        <thead>
                                            <tr>
                                                <th style={{ width: '50%' }} className="text-uppercase text-primary">Título</th>
                                                <th style={{ width: '20%' }} className="text-uppercase text-primary">Posición</th>
                                                <th style={{ width: '30%' }} className="text-uppercase text-primary">Acciones</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {lecciones.filter(leccion => leccion.level === nivel).map((leccion) => (
                                                <SortableRow key={leccion.id} id={leccion.id}>
                                                    {/* Título */}
                                                    {leccion.titulo}
                                                    {/* Posición */}
                                                    <td>
                                                        <Badge bg="info" className="px-3 py-2">
                                                            {leccion.orden || leccion.posicion || ''}
                                                        </Badge>
                                                    </td>
                                                    {/* Acciones */}
                                                    <td>
                                                        <div className="lecturas-actions d-flex gap-2 justify-content-end">
                                                            <Button variant="info" onClick={() => handleEdit(leccion)} size="sm" className="d-flex align-items-center">
                                                                <span className="me-1">✏️</span> Editar
                                                            </Button>
                                                            <Button variant="danger" onClick={() => handleDelete(leccion.id)} size="sm" className="d-flex align-items-center">
                                                                <span className="me-1">🗑️</span> Eliminar
                                                            </Button>
                                                        </div>
                                                    </td>
                                                </SortableRow>
                                            ))}
                                        </tbody>
                                    </Table>
                                </SortableContext>
                            </DndContext>
                        </Tab>
                    ))}
                </Tabs>
            )}
        </div>
    );

    return (
        <div>
            <NavbarGlobal 
                title="Añadir Material Teórico"
                showBackButton={true}
            />
            <Container>
                <Tabs 
                    activeKey={mainTab} 
                    onSelect={(k) => setMainTab(k)} 
                    className="mb-4"
                    justify
                >
                    <Tab eventKey="formulario" title="Formulario">
                        <div className="lecturas-form-container">
                            <Alert variant="info" className="mb-4">
                                <Alert.Heading>📝 Información</Alert.Heading>
                                <p>
                                    Completa el formulario para añadir una nueva lección teórica. Asegúrate de seleccionar el nivel correcto y proporcionar una descripción detallada.
                                </p>
                            </Alert>
                            <FormularioAgregarLeccion 
                            leccionActual={leccionActual}
                            setLeccionActual={setLeccionActual}
                            handleAddLeccion={handleAddLeccion}
                            handleImageChange={handleImageChange}
                        />
                        </div>
                    </Tab>
                    <Tab eventKey="lecciones" title="Lecciones">
                        <ListadoLecciones />
                    </Tab>
                </Tabs>
                <Modal show={showModal} onHide={handleCloseModal} size="xl" centered dialogClassName="lesson-edit-dialog">
                    <Modal.Header closeButton>
                        <Modal.Title>Editar Lección</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="lesson-edit-body">
                        <div className="lesson-form-shell lesson-edit-shell">
                            <Form className="lesson-edit-form">
                                <FormGroup className="mb-3">
                                    <FormLabel>Nivel</FormLabel>
                                    <Form.Select value={editingLesson?.level} onChange={(e) => setEditingLesson({ ...editingLesson, level: e.target.value })}>
                                        <option value="1">Nivel 1</option>
                                        <option value="2">Nivel 2</option>
                                        <option value="3">Nivel 3</option>
                                    </Form.Select>
                                </FormGroup>
                                <FormGroup className="mb-3">
                                    <FormLabel>Título</FormLabel>
                                    <FormControl
                                        type="text"
                                        value={editingLesson?.titulo}
                                        onChange={(e) => setEditingLesson(prev => ({ ...prev, titulo: e.target.value }))}
                                        autoComplete="off"
                                    />
                                </FormGroup>
                                <FormGroup className="mb-3">
                                    <FormLabel>Descripción</FormLabel>
                                    <div className="lesson-editor-surface">
                                        <TiptapEditor
                                            value={editingLesson?.descripcion || ''}
                                            onChange={content => setEditingLesson({ ...editingLesson, descripcion: content })}
                                            placeholder="Ingresa una descripción"
                                            imageFolder="material-teorico"
                                            columnCount={editingLesson?.columnasDescripcion || '1'}
                                            className="lesson-tiptap-editor"
                                        />
                                    </div>
                                </FormGroup>
                                <FormGroup className="mb-3">
                                    <FormLabel>Columnas de Descripción</FormLabel>
                                    <Form.Select 
                                        value={editingLesson?.columnasDescripcion || '1'} 
                                        onChange={(e) => setEditingLesson({ ...editingLesson, columnasDescripcion: e.target.value })}
                                    >
                                        <option value="1">1 Columna</option>
                                        <option value="2">2 Columnas</option>
                                    </Form.Select>
                                </FormGroup>
                                <FormGroup className="mb-3">
                                    <FormLabel>Imagen Destacada</FormLabel>
                                    {editingLesson?.imagenDestacada && !deleteImage && (
                                        <div className="mb-3">
                                            <img 
                                                src={editingLesson.imagenDestacada} 
                                                alt="Imagen actual" 
                                                style={{ maxWidth: '300px', maxHeight: '200px', marginBottom: '10px' }} 
                                            />
                                            <p>Imagen actual</p>
                                            <Button 
                                                variant="danger" 
                                                size="sm" 
                                                onClick={() => setDeleteImage(true)}
                                                className="mb-3"
                                            >
                                                Eliminar imagen
                                            </Button>
                                        </div>
                                    )}
                                    {deleteImage && (
                                        <div className="alert alert-warning mb-3">
                                            La imagen será eliminada al guardar los cambios.
                                            <Button 
                                                variant="outline-secondary" 
                                                size="sm" 
                                                onClick={() => setDeleteImage(false)}
                                                className="ms-2"
                                            >
                                                Cancelar
                                            </Button>
                                        </div>
                                    )}
                                    <FormControl
                                        type="file"
                                        onChange={handleImageChange}
                                        accept="image/*"
                                    />
                                    {imageFile && (
                                        <p className="mt-2">Nueva imagen seleccionada: {imageFile.name}</p>
                                    )}
                                </FormGroup>
                            </Form>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setShowModal(false)}>Cerrar</Button>
                        <Button variant="primary" onClick={() => handleUpdateLesson(editingLesson)}>Guardar Cambios</Button>
                    </Modal.Footer>
                </Modal>
                <ToastContainer position="bottom-end" className="p-3">
                    <Toast onClose={() => setShowToast(false)} show={showToast} delay={3000} autohide>
                        <Toast.Header>
                            <strong className="me-auto">Notificación</strong>
                        </Toast.Header>
                        <Toast.Body>{toastMessage}</Toast.Body>
                    </Toast>
                </ToastContainer>
            </Container>
        </div>
    );
};

export { AddMaterialTeorico };
